// @flow
import actionTypes from '../actionTypes';
import { fetch } from '../../api';

export function loginFailure(error: any) {
  const type = actionTypes.LOG_IN_FAILURE;
  return { type, alert: { type }, error };
}

type LoginSuccessData = { session: string, isActive: boolean, user: User, locale: string};
export function loginSuccess({ session, isActive, user, locale = 'en' }: LoginSuccessData): any {
  if (!user) return loginFailure('no user returned by api');

  (user.groups || [])
    .forEach(group => group.isFollowedByCurrentUser = true);

  return {
    type: actionTypes.LOG_IN_SUCCESS,
    session: { session, isActive, userId: user.id, locale },
    data: { users: [user] },
  };
}

type LoginData = { password: string, username: string, staySignedIn: boolean };
export function login({ password, username, staySignedIn = true }: LoginData) {
  return async function(dispatch: Dispatch) {
    dispatch({ type: actionTypes.LOG_IN });

    try {
      const body = JSON.stringify({ password, username, staySignedIn });
      const { payload } = await fetch('session', { method: 'POST', body });

      dispatch(loginSuccess(payload));
    } catch (error) {
      dispatch(loginFailure(error));
    }
  };
}

export function logout() {
  return async function(dispatch: Dispatch) {
    dispatch({ type: actionTypes.LOG_OUT });

    try {
      await fetch('session', { method: 'DELETE' });
      dispatch({ type: actionTypes.LOG_OUT_SUCCESS });
    } catch (error) {
      dispatch({ type: actionTypes.LOG_OUT_FAILURE, error });
    }
  };
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/userFlowActionsCreator/login.js